import { forwardRef, createElement } from 'react';

function IconShowLess(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M3.75 4a.75.75 0 01.75.75v14.5a.75.75 0 11-1.5 0V4.75A.75.75 0 013.75 4zm3.5 0a.75.75 0 01.75.75v14.5a.75.75 0 11-1.5 0V4.75A.75.75 0 017.25 4zm7.78 3.97a.75.75 0 01.073.976l-.073.084-2.219 2.22h7.439a.75.75 0 01.102 1.493l-.102.007h-7.439l2.22 2.22a.75.75 0 01-.977 1.133l-.084-.073-3.5-3.5-.055-.06-.046-.065-.049-.088-.044-.12-.018-.089-.007-.143.019-.136.03-.098.047-.1.054-.082.069-.08 3.5-3.5a.75.75 0 011.06 0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var ShowLess = /*#__PURE__*/forwardRef(IconShowLess);

export default ShowLess;
//# sourceMappingURL=ShowLess.js.map
